import * as Yup from 'yup';

const pLatin = `a-zA-ZáàâäãåçéèêëíìîïñóòôöõúùûüýÿæœÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸÆŒ`;

export const schema = Yup.object({
	// first step
	customers_rfc: Yup.string()
		.required()
		.matches(new RegExp(`^([${pLatin}@&]{3,4})(\\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\\d|3[01]))([${pLatin}\\d@&]{3})$`), { excludeEmptyString: true }),
	customers_name: Yup.string().min(1).max(400).required(),
	address_pais: Yup
		.object().shape({
			label: Yup.string().required(),
			value: Yup.string().required(),
			disabled: Yup.boolean().notRequired().nullable(true)
		})
		.required(),
	customers_email: Yup.string().required().email(),
	customers_num_regid_trib: Yup.string()
		.notRequired()
		.transform((value: string, originalValue: string) => (originalValue === '' ? null : value))
		.min(3)
		.max(10)
		.nullable(true),
	cat_tax_regime_id: Yup
		.object().shape({
			label: Yup.string().required(),
			value: Yup.string().required(),
			disabled: Yup.boolean().notRequired().nullable(true)
		})
		.required(),

	// second step
	address_calle: Yup.string()
		.notRequired()
		.transform((value: string, originalValue: string) => (originalValue === '' ? null : value))
		.min(3)
		.max(250)
		.nullable(true),
	address_no_exterior: Yup.string()
		.notRequired()
		.transform((value: string, originalValue: string) => (originalValue === '' ? null : value))
		.min(1)
		.max(250)
		.nullable(true),
	address_no_interior: Yup.string()
		.notRequired()
		.transform((value: string, originalValue: string) => (originalValue === '' ? null : value))
		.min(1)
		.max(250)
		.nullable(true),
	address_colonia: Yup.string()
		.notRequired()
		.transform((value: string, originalValue: string) => (originalValue === '' ? null : value))
		.min(3)
		.max(250)
		.nullable(true),
	address_referencia: Yup.string()
		.notRequired()
		.transform((value: string, originalValue: string) => (originalValue === '' ? null : value))
		.min(3)
		.max(250)
		.nullable(true),
	address_municipio: Yup.string()
		.notRequired()
		.transform((value: string, originalValue: string) => (originalValue === '' ? null : value))
		.min(3)
		.max(100)
		.nullable(true),
	address_localidad: Yup.string()
		.notRequired()
		.transform((value: string, originalValue: string) => (originalValue === '' ? null : value))
		.min(1)
		.max(250)
		.nullable(true),
	address_estado: Yup.string()
		.notRequired()
		.transform((value: string, originalValue: string) => (originalValue === '' ? null : value))
		.min(3)
		.max(250)
		.nullable(true),
	address_codigo_postal: Yup.string().min(3).max(100).required(), // se vuelve mínimo de captura

	// third step
	customers_telefono: Yup.string()
		.notRequired()
		.transform((value: string, originalValue: string) => (originalValue === '' ? null : value))
		.min(3)
		.max(14)
		.nullable(true),
	customers_fax: Yup.string()
		.notRequired()
		.transform((value: string, originalValue: string) => (originalValue === '' ? null : value))
		.min(3)
		.max(14)
		.nullable(true),
	customers_email_2: Yup.string().email().nullable(true),
	customers_email_3: Yup.string().email().nullable(true),
	customers_pagina_web: Yup.string()
		.notRequired()
		.transform((value: string, originalValue: string) => (originalValue === '' ? null : value))
		.min(3)
		.max(100)
		.nullable(true),
});
